import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type AssignableAccountsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  searchAssignableAccountsFiltersInput: GraphQLTypes.SearchAssignableAccountsFiltersInput;
  after?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  before?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
  first?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
  last?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Int']['input']>;
}>;

export type AssignableAccountsQueryResult = { __typename?: 'Query' } & {
  searchAssignableAccounts?: GraphQLTypes.Maybe<
    { __typename?: 'AccountConnectionTypeConnection' } & {
      nodes: Array<
        GraphQLTypes.Maybe<
          { __typename?: 'AccountConnectionType' } & Pick<GraphQLTypes.AccountConnectionType, 'connectionType'> & {
              account: { __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'> & {
                  label?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>>;
                };
            }
        >
      >;
    }
  >;
};

export const AssignableAccountsDocument = gql`
  query assignableAccounts(
    $accountId: String!
    $searchAssignableAccountsFiltersInput: SearchAssignableAccountsFiltersInput!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    searchAssignableAccounts(
      accountId: $accountId
      searchAssignableAccountsFiltersInput: $searchAssignableAccountsFiltersInput
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      nodes {
        account {
          id
          label {
            long
          }
          tradingName
        }
        connectionType
      }
    }
  }
`;
